/* CoThings Mega Menu — Sidebar hover + AJAX tab switching */
(function() {
  var debounceTimer = null;
  var productCache = {};

  function loadProducts(container, collectionHandle) {
    if (!collectionHandle) return;

    // Check cache
    if (productCache[collectionHandle]) {
      container.innerHTML = productCache[collectionHandle];
      return;
    }

    container.innerHTML = '<div class="ct-megamenu-loading">Chargement...</div>';

    fetch('/collections/' + collectionHandle + '/products.json?limit=20')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = '';
        // Show all products (including out-of-stock), take first 10
        var available = (data.products || []).slice(0, 10);
        if (available.length > 0) {
          available.forEach(function(p) {
            var imgSrc = '';
            if (p.images && p.images.length > 0) {
              var src = p.images[0].src;
              // Handle both old and new Shopify CDN URLs
              if (src.indexOf('/files/') > -1) {
                // New CDN: use query params
                imgSrc = src.split('?')[0] + '?width=160&height=160&crop=center';
              } else {
                // Old CDN: use suffix
                imgSrc = src.replace(/\.([^.]+)$/, '_160x160_crop_center.$1');
              }
            }
            var title = p.title.length > 40 ? p.title.substring(0, 37) + '...' : p.title;
            html += '<a href="/products/' + p.handle + '" class="ct-megamenu-product">';
            html += '<div class="ct-megamenu-product-img">';
            if (imgSrc) {
              html += '<img src="' + imgSrc + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" width="160" height="160">';
            } else {
              html += '<div class="ct-megamenu-product-placeholder"></div>';
            }
            html += '</div>';
            html += '<p class="ct-megamenu-product-name">' + title + '</p>';
            html += '</a>';
          });
        } else {
          html = '<div class="ct-megamenu-empty"><a href="/collections/' + collectionHandle + '" class="ct-megamenu-browse-btn">Parcourir la collection <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg></a></div>';
        }
        productCache[collectionHandle] = html;
        container.innerHTML = html;
      })
      .catch(function() {
        container.innerHTML = '<div class="ct-megamenu-empty"><a href="/collections/' + collectionHandle + '" class="ct-megamenu-browse-btn">Voir la collection</a></div>';
      });
  }

  function initMegaMenu() {
    // Sidebar item hover — switch category panels + load products
    document.querySelectorAll('.ct-megamenu-sidebar-item').forEach(function(item) {
      item.addEventListener('mouseenter', function() {
        var sidebar = this.closest('.ct-megamenu-sidebar');
        var content = this.closest('.ct-megamenu-panel-inner').querySelector('.ct-megamenu-content');
        var catIndex = this.getAttribute('data-cat-index');

        // Update sidebar active
        sidebar.querySelectorAll('.ct-megamenu-sidebar-item').forEach(function(el) { el.classList.remove('active'); });
        this.classList.add('active');

        // Switch panel
        content.querySelectorAll('.ct-megamenu-cat-panel').forEach(function(el) { el.classList.remove('active'); });
        var target = content.querySelector('[data-cat-panel="' + catIndex + '"]');
        if (target) {
          target.classList.add('active');

          // Load products for the default (first) tab or parent collection
          var productsDiv = target.querySelector('.ct-megamenu-products');
          var activeTab = target.querySelector('.ct-megamenu-tab.active');
          var colHandle = activeTab ? activeTab.getAttribute('data-tab-col') : productsDiv.getAttribute('data-collection');
          if (colHandle && productsDiv.querySelector('.ct-megamenu-loading')) {
            loadProducts(productsDiv, colHandle);
          }
        }
      });
    });

    // Tab hover — switch sub-category products via AJAX
    document.querySelectorAll('.ct-megamenu-tab').forEach(function(tab) {
      tab.addEventListener('mouseenter', function() {
        var panel = this.closest('.ct-megamenu-cat-panel');
        var colHandle = this.getAttribute('data-tab-col');

        // Update active tab style
        panel.querySelectorAll('.ct-megamenu-tab').forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');

        // Load products into the grid
        var productsDiv = panel.querySelector('.ct-megamenu-products');
        if (productsDiv && colHandle) {
          productsDiv.setAttribute('data-collection', colHandle);
          loadProducts(productsDiv, colHandle);
        }
      });

      // Click navigates to collection page
      tab.addEventListener('click', function(e) {
        // Allow natural link navigation
      });
    });

    // Keep dropdown open when hovering inside panel
    document.querySelectorAll('.ct-megamenu-panel').forEach(function(panel) {
      panel.addEventListener('mouseenter', function() {
        clearTimeout(debounceTimer);
        this.closest('.ct-megamenu-group').classList.add('show');
      });
      panel.addEventListener('mouseleave', function() {
        var group = this.closest('.ct-megamenu-group');
        debounceTimer = setTimeout(function() { group.classList.remove('show'); }, 100);
      });
    });

    // Group link hover — close all others first
    document.querySelectorAll('.ct-megamenu-group').forEach(function(group) {
      group.addEventListener('mouseenter', function() {
        clearTimeout(debounceTimer);
        // Close all other groups
        document.querySelectorAll('.ct-megamenu-group.show').forEach(function(g) {
          if (g !== group) g.classList.remove('show');
        });
        this.classList.add('show');

        // Auto-load products for the first visible category
        var panel = this.querySelector('.ct-megamenu-cat-panel.active');
        if (panel) {
          var productsDiv = panel.querySelector('.ct-megamenu-products');
          var activeTab = panel.querySelector('.ct-megamenu-tab.active');
          var colHandle = activeTab ? activeTab.getAttribute('data-tab-col') : productsDiv.getAttribute('data-collection');
          if (colHandle && productsDiv.querySelector('.ct-megamenu-loading')) {
            loadProducts(productsDiv, colHandle);
          }
        }
      });
      group.addEventListener('mouseleave', function() {
        var el = this;
        debounceTimer = setTimeout(function() { el.classList.remove('show'); }, 150);
      });
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }
})();
